var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data!==null)?_c('div',{staticClass:"chart"},[_c('div',{staticClass:"variable-pie"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }